// extracted by mini-css-extract-plugin
export var modal = "_mj-0";